<template>
  <div class="el-stripe">
    <!-- Código de verificaçao cvv -->
    <cvv
      :title="$t('account.settings.cvv.title')"
      :callback="saveForceCvv"
      :loading="accountLoading"
      :formIsInvalid="$v.forceCvv.$invalid"
      @cancelEdit="resetObject(forceCvv, recurrenceSettings.forceCvv)"
      :hideEditButton="!permissionIsEnabled('settings.force_cvv:edit')"
      v-if="permissionIsEnabled('settings.force_cvv:view')"
    >
      <template slot="content">
        <div class="emd-panel">
          <div class="emd-panel__section">
            <div class="emd-panel__block">
              <div class="el-chunk">
                <h2 class="emd-text _color_default _type_caption">
                  {{ $t('account.settings.cvv.config') }}
                </h2>
              </div>
              <div class="el-chunk">
                <p class="emd-text _color_nonessential _size_small">
                  {{ $t('account.settings.cvv.config-detail') }}
                </p>
              </div>
            </div>
            <div class="emd-panel__block">
              <div class="emd-form-group">
                <label
                  class="emd-label"
                  for="enableForceCvv"
                  >{{ $t('account.settings.cvv.status') }}</label
                >
                <span class="emd-input-helper"></span>
                <label
                  class="emd-switcher__label"
                  for="enableForceCvv"
                >
                  <input
                    class="emd-switcher _color_success"
                    type="checkbox"
                    id="enableForceCvv"
                    v-model="forceCvv.force_cvv"
                  />
                  <div class="emd-switcher__area"></div>
                  <span class="emd-switcher__text">{{
                    $t('account.settings.cvv.active')
                  }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </template>
    </cvv>
    <!-- Assinaturas -->
    <subscriptions
      :title="$t('account.settings.subscriptions.title')"
      :callback="saveSubscriptionsSettings"
      :loading="accountLoading"
      :formIsInvalid="$v.subscriptions.$invalid"
      @cancelEdit="resetObject(subscriptions, recurrenceSettings.subscriptions)"
      :hideEditButton="!permissionIsEnabled('settings.subscriptions:edit')"
      v-if="permissionIsEnabled('settings.subscriptions:view')"
    >
      <template slot="content">
        <div class="emd-panel">
          <div class="emd-panel__section">
            <div class="emd-panel__block">
              <div class="el-chunk">
                <h2 class="emd-text _color_default _type_caption">
                  {{ $t('account.settings.subscriptions.config') }}
                </h2>
              </div>
            </div>
            <div class="emd-panel__block">
              <!-- Enable subscriptions -->
              <div class="emd-form-group">
                <label
                  class="emd-label"
                  for="status"
                  >{{ $t('account.settings.subscriptions.status') }}</label
                >
                <span class="emd-input-helper"></span>
                <label
                  class="emd-switcher__label"
                  for="enableSubscriptions"
                >
                  <input
                    class="emd-switcher _color_success"
                    type="checkbox"
                    id="enableSubscriptions"
                    v-model="subscriptions.enabled"
                  />
                  <div class="emd-switcher__area"></div>
                  <span class="emd-switcher__text">{{
                    $t('account.settings.subscriptions.active')
                  }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="emd-panel">
          <div class="emd-panel__section">
            <div class="emd-panel__block">
              <div class="el-chunk">
                <p class="emd-text _color_nonessential _size_small">
                  {{ $t('account.settings.subscriptions.due-days-detail') }}
                </p>
              </div>
            </div>
            <div class="emd-panel__block">
              <!-- Due days -->
              <div class="emd-form-group _condensed_30">
                <label
                  class="emd-label"
                  for="status"
                  >{{ $t('account.settings.subscriptions.due-days') }}</label
                >
                <input
                  class="emd-input"
                  id="dueDays"
                  type="text"
                  v-model="subscriptions.boleto_due_days"
                  :placeholder="
                    $t('account.settings.subscriptions.due-days-placeholder')
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </template>
    </subscriptions>
    <!-- Retentativa offline - Assinaturas -->
    <subscription-attempt
      :title="$t('account.settings.subscription-attempt.title')"
      :callback="saveSubscriptionAttemptSettings"
      :loading="attemptLoading"
      :formIsInvalid="$v.subscriptionAttempt.$invalid"
      @cancelEdit="resetObject(subscriptionAttempt, attemptSettings)"
      :hideEditButton="
        !permissionIsEnabled('settings.subscription_attempt:edit')
      "
      v-if="permissionIsEnabled('settings.attempts:search')"
    >
      <template slot="content">
        <div class="emd-panel">
          <div class="emd-panel__section">
            <div class="emd-panel__block">
              <div class="el-chunk">
                <h2 class="emd-text _color_default _type_caption">
                  {{ $t('account.settings.subscription-attempt.config') }}
                </h2>
              </div>
              <div class="el-chunk">
                <p class="emd-text _color_nonessential _size_small">
                  {{
                    $t('account.settings.subscription-attempt.status-detail')
                  }}
                </p>
              </div>
            </div>
            <div class="emd-panel__block">
              <!-- Status subscriptionAttempt -->
              <div class="emd-form-group">
                <label
                  class="emd-label"
                  for="status"
                  >{{
                    $t('account.settings.subscription-attempt.status')
                  }}</label
                >
                <span class="emd-input-helper"></span>
                <label
                  class="emd-switcher__label"
                  for="enableSubscriptionAttempt"
                >
                  <input
                    class="emd-switcher _color_success"
                    type="checkbox"
                    id="enableSubscriptionAttempt"
                    true-value="active"
                    false-value="inactive"
                    v-model="subscriptionAttempt.status"
                  />
                  <div class="emd-switcher__area"></div>
                  <span class="emd-switcher__text">{{
                    $t('account.settings.subscription-attempt.active')
                  }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="emd-panel">
          <div class="emd-panel__section">
            <div class="emd-panel__block">
              <div class="el-chunk">
                <h2 class="emd-text _color_default _type_caption">
                  {{ $t('account.settings.subscription-attempt.intervals') }}
                </h2>
              </div>
              <div class="el-chunk">
                <p class="emd-text _color_nonessential _size_small">
                  {{
                    $t('account.settings.subscription-attempt.intervals-detail')
                  }}
                </p>
              </div>
            </div>
            <div class="emd-panel__block">
              <!-- Intervals subscriptionAttempt -->
              <div class="emd-form-group _condensed_50">
                <label
                  class="emd-label"
                  v-bind:class="{
                    _required: subscriptionAttempt.status === 'active'
                  }"
                  >{{
                    $t('account.settings.subscription-attempt.interval-number')
                  }}</label
                >
                <ul
                  v-if="attemptIntervals.length > 0"
                  class="emd-list _space_base"
                >
                  <li
                    v-for="(interval, index) in attemptIntervals"
                    :key="index"
                  >
                    <div class="emd-input-group">
                      <input
                        type="number"
                        class="emd-input"
                        name="interval[]"
                        :max="maxAttempt"
                        v-model="interval.value"
                        @input="validateInterval(index, interval.value)"
                        v-bind:class="{ _state_error: sumOfAttempts > 7200 }"
                      />
                      <button
                        class="emd-btn _color_danger _type_text"
                        type="button"
                        v-on:click="removeInterval(index)"
                        v-if="
                          index !== 0 ||
                          (index === 0 && attemptIntervals.length > 1)
                        "
                      >
                        <i class="uil uil-minus-circle" />
                      </button>
                    </div>
                  </li>
                  <button
                    class="emd-btn _color_primary"
                    type="button"
                    v-on:click="addInterval()"
                    :disabled="
                      attemptIntervals.length > 5 ||
                      !attemptIntervals[attemptIntervals.length - 1].value ||
                      attemptIntervals[attemptIntervals.length - 1].value < 1
                    "
                  >
                    <i class="uil uil-plus" />
                    {{ $t('account.settings.subscription-attempt.add-retry') }}
                  </button>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </template>
    </subscription-attempt>

    <!-- Renovação de cartões -->
    <card-updater
      :title="$t('account.settings.card-updater.title')"
      :callback="saveCardUpdaterSettings"
      :loading="accountLoading"
      :formIsInvalid="$v.cardUpdater.$invalid"
      @cancelEdit="resetObject(cardUpdater, recurrenceSettings.cardUpdater)"
      :hideEditButton="!permissionIsEnabled('settings.card_updater:edit')"
      v-if="permissionIsEnabled('settings.card_updater:view')"
    >
      <template slot="content">
        <div class="emd-panel">
          <div class="emd-panel__section">
            <div class="emd-panel__block">
              <div class="el-chunk">
                <h2 class="emd-text _color_default _type_caption">
                  {{ $t('account.settings.card-updater.manual-renovation') }}
                </h2>
              </div>
              <div class="el-chunk">
                <p class="emd-text _color_nonessential _size_small">
                  {{
                    $t('account.settings.card-updater.manual-renovation-detail')
                  }}
                </p>
              </div>
            </div>
            <div class="emd-panel__block">
              <!-- Status manual renovation -->
              <div class="emd-form-group">
                <label
                  class="emd-label"
                  for="status"
                  >{{ $t('account.settings.card-updater.status') }}</label
                >
                <span class="emd-input-helper"></span>
                <label
                  class="emd-switcher__label"
                  for="enableManual"
                >
                  <input
                    class="emd-switcher _color_success"
                    type="checkbox"
                    id="enableManual"
                    v-model="cardUpdater.manual_renew_enabled"
                  />
                  <div class="emd-switcher__area"></div>
                  <span class="emd-switcher__text">{{
                    $t('account.settings.card-updater.active')
                  }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="emd-panel">
          <div class="emd-panel__section">
            <div class="emd-panel__block">
              <div class="el-chunk">
                <h2 class="emd-text _color_default _type_caption">
                  {{ $t('account.settings.card-updater.automatic-renovation') }}
                </h2>
              </div>
              <div class="el-chunk">
                <p class="emd-text _color_nonessential _size_small">
                  {{
                    $t(
                      'account.settings.card-updater.automatic-renovation-detail'
                    )
                  }}
                </p>
              </div>
            </div>
            <div class="emd-panel__block">
              <!-- Status automatic renovation -->
              <div class="emd-form-group">
                <label
                  class="emd-label"
                  for="status"
                  >{{ $t('account.settings.card-updater.status') }}</label
                >
                <span class="emd-input-helper"></span>
                <label
                  class="emd-switcher__label"
                  for="enableAutomatic"
                >
                  <input
                    class="emd-switcher _color_success"
                    type="checkbox"
                    id="enableAutomatic"
                    v-model="cardUpdater.renew_on_payment_enabled"
                  />
                  <div class="emd-switcher__area"></div>
                  <span class="emd-switcher__text">{{
                    $t('account.settings.card-updater.active')
                  }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </template>
    </card-updater>
  </div>
</template>
<script>
import ConfigBox from '@/components/project/molecules/ConfigBox.vue'
import { requiredIf } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
export default {
  name: 'Functionalities',
  components: {
    SubscriptionAttempt: ConfigBox,
    CardUpdater: ConfigBox,
    Subscriptions: ConfigBox,
    Cvv: ConfigBox
  },
  data () {
    return {
      subscriptionAttempt: {
        status: 'inactive',
        type: 'subscription',
        intervals: []
      },
      cardUpdater: {
        manual_renew_enabled: null,
        renew_on_payment_enabled: null
      },
      subscriptions: {},
      attemptIntervals: [],
      forceCvv: {}
    }
  },
  validations: {
    subscriptionAttempt: {
      status: {
        required: false
      },
      intervals: {
        required: requiredIf(function () {
          return this.subscriptionAttempt.status === 'active'
        })
      }
    },
    forceCvv: {
      force_cvv: {
        required: true
      }
    },
    cardUpdater: {
      manual_renew_enabled: {
        required: false
      },
      renew_on_payment_enabled: {
        required: false
      }
    },
    subscriptions: {
      enabled: {
        required: false,
        boleto_due_days: {
          required: false
        }
      }
    }
  },
  computed: {
    recurrenceSettings: {
      get () {
        return this.$store.getters.recurrenceSettings
      }
    },
    attemptSettings: {
      get () {
        return this.$store.getters.attemptSettings
      }
    },
    attemptLoading () {
      return this.$store.getters.attemptLoading
    },
    accountLoading () {
      return this.$store.getters.accountLoading
    },
    params: function () {
      return {
        merchantId: this.$store.getters.merchantId,
        accountId: this.$store.getters.accountId
      }
    },
    sumOfAttempts () {
      let total = 0
      this.attemptIntervals.forEach(interval => {
        if (interval.value) total = total + parseInt(interval.value)
      })
      return total
    },
    maxAttempt () {
      return 7200 - this.sumOfAttempts
    }
  },
  methods: {
    ...mapActions({
      updateForceCvvSettings: 'UPDATE_FORCE_CVV_SETTINGS',
      updateSubscriptionsSettings: 'UPDATE_SUBSCRIPTIONS_SETTINGS'
    }),
    saveSubscriptionAttemptSettings (password) {
      const params = this.params
      this.subscriptionAttempt.password = password
      this.subscriptionAttempt.intervals = []
      this.attemptIntervals.forEach(interval => {
        if (interval.value)
          this.subscriptionAttempt.intervals.push(parseInt(interval.value))
      })
      params.body = this.subscriptionAttempt

      if (this.subscriptionAttempt.id) {
        params.attemptId = this.subscriptionAttempt.id
        this.subscriptionAttempt.password = password
        return this.$store.dispatch('UPDATE_ATTEMPT_SETTINGS', params)
      } else if (
        !this.subscriptionAttempt.id &&
        this.subscriptionAttempt.status === 'active'
      ) {
        return this.$store.dispatch('CREATE_ATTEMPT_SETTINGS', params)
      } else if (!this.subscriptionAttempt.id) {
        return Promise.resolve(true)
      }
    },
    saveCardUpdaterSettings (password) {
      this.cardUpdater.password = password
      return this.$store.dispatch(
        'UPDATE_RENEW_CARD_SETTINGS',
        this.cardUpdater
      )
    },
    saveForceCvv (password) {
      this.forceCvv.password = password
      return this.updateForceCvvSettings(this.forceCvv)
    },
    saveSubscriptionsSettings (password) {
      this.subscriptions.password = password
      return this.updateSubscriptionsSettings(this.subscriptions)
    },
    prepareIntervals (attempt) {
      this.attemptIntervals = []
      if (!attempt || (attempt && attempt.status === 'inactive')) {
        this.attemptIntervals = [
          {
            value: null
          }
        ]
      } else if (attempt && attempt.intervals.length) {
        attempt.intervals.forEach(interval => {
          this.attemptIntervals.push({ value: interval })
        })
      }
    },
    addInterval () {
      if (this.attemptIntervals.length < 6) {
        this.attemptIntervals.push({ value: null })
      }
    },
    removeInterval (index) {
      this.attemptIntervals.splice(index, 1)
    },
    validateInterval (index, value) {
      if (this.sumOfAttempts <= 7200) {
        this.refreshIntervals(index, value)
      } else {
        this.subscriptionAttempt.intervals = []
      }
    },
    refreshIntervals (index, value) {
      this.subscriptionAttempt.intervals = []
      this.attemptIntervals.forEach(interval => {
        if (interval.value)
          this.subscriptionAttempt.intervals.push(parseInt(interval.value))
      })
    },
    resetObject (obj, objFromApi) {
      if (Object.prototype.hasOwnProperty.call(obj, 'intervals')) {
        obj = Object.assign(
          {
            status: 'inactive',
            type: 'subscription',
            intervals: []
          },
          objFromApi.find(attempt => attempt.type === 'subscription')
        )
        this.subscriptionAttempt.status = obj.status
        this.prepareIntervals(obj)
      } else {
        obj = Object.assign(obj, objFromApi)
      }
    },
    permissionIsEnabled (action) {
      return this.$store.getters.permissionIsEnabled(action)
    }
  },
  created () {
    this.$store.dispatch('GET_ACCOUNT', this.params).then(res => {
      this.cardUpdater = Object.assign(
        this.cardUpdater,
        this.recurrenceSettings.cardUpdater
      )
      this.subscriptions = Object.assign(
        {},
        this.recurrenceSettings.subscriptions
      )
      this.forceCvv = Object.assign({}, this.recurrenceSettings.forceCvv)
    })
    if (this.permissionIsEnabled('settings.attempts:search')) {
      this.$store.dispatch('GET_ATTEMPT_SETTINGS', this.params).then(res => {
        this.subscriptionAttempt = Object.assign(
          this.subscriptionAttempt,
          this.attemptSettings.find(attempt => attempt.type === 'subscription')
        )
        this.prepareIntervals(this.subscriptionAttempt)
      })
    }
  }
}
</script>
